import { CourseInfo, CourseModel } from '@descomplica/dex-models';

const categories = new Map([
  ['vestibulares', 'Vestibulares'],
  ['vida', 'Vida'],
  ['escolas', 'Escolas'],
  ['universidades', 'Universidades'],
  ['pos', 'Pós'],
  ['certificados', 'Certificados'],
  ['concursos', 'Concursos'],
  ['universo-descomplica', 'Universo Descomplica'],
  ['parceiros', 'Parceiros'],
  ['graduacao', 'Graduação'],
  ['cursos-livres', 'Cursos Livres'],
]);

class Category {
  static getNameBySlug(slug: string | null): string | null {
    if (slug === null) return slug;
    return categories.get(slug.toLowerCase()) || slug;
  }
}

export const DEFAULT_CATEGORY = 'curso';

export const UNDERGRADUATE_CATEGORY_SLUG = 'graduacao';

export const getCourseCategory = (course?: CourseModel): string | null => {
  if (!course) return null;
  return course.descomplicaCategorySlug || UNDERGRADUATE_CATEGORY_SLUG;
};

export const getCourseInfoCategory = (course?: CourseInfo): string | null => {
  if (!course) return null;
  return course.descomplicaCategorySlug || UNDERGRADUATE_CATEGORY_SLUG;
};

export default Category;
